/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import customModal from "../customModal/customModal.vue";
import ManageSDVRule from "./ManageSDVRule.vue";

export default {
  name: "ManageSDVRuleList",
  props: {
    planId: { type: String, required: true },
    planVersion: { type: Number, default: 0 },
     planStatus: { type: String, default: "" },
  },
  computed: {
  isPlanEditable() {
    return this.planStatus === "Draft";
  },
},
  components: {
    customModal,
    ManageSDVRule,
    VPagination,
  },
  data() {
    return {
      showLoading: true,
      ruleList: [],
      viewMode: false,
      showCreateRuleModal: false,
      editingRuleId: null,
      baseurl: process.env.VUE_APP_Service_URL,
      token: "",
      currentPage: 1,
      totalItems: 0,
      studyId: store.getters.getStudyIs,
      
      ruleNameSearch: "",
      ruleTypeSearch: "",
      roleprivileges:"",
      pageSize: 10,
      SortProperty: "Priority",
      SortOrder: "asc",
      sitesMap: {},
     visitsMap: {},
    };
  },
async mounted() {
  this.token = store.getters.getIdToken;
  await this.setroleprivileges();
  this.showLoading = true;

  try {
    await Promise.all([
      this.getRules(),
      this.loadSites(),
      this.loadVisits()
    ]);
  } catch (err) {
    console.error("Error loading initial data:", err);
  } finally {
    this.showLoading = false;
  }
},
  methods: {
    async getRules() {
     
      try {
        const params = {
          planId: this.planId, // use prop
          studyId: this.studyId,
          pageindex: this.currentPage,
          pagesize: this.pageSize,
          SortProperty: this.SortProperty,
          SortOrder: this.SortOrder,
        };
        if (this.ruleNameSearch) params.ruleName = this.ruleNameSearch;
        if (this.ruleTypeSearch) params.ruleType = this.ruleTypeSearch;

        const response = await axios.get(
          `${this.baseurl}/management/sdv/getsdvplanrules`,
          { params, headers: { Authorization: "Bearer " + this.token, "Content-Type": "application/json" } }
        );
        console.log("Rules response:", response.data);
        this.ruleList = response.data?.entities || [];
        this.totalItems = Math.ceil((response.data?.totalCount || 0) / this.pageSize);
      } catch (err) {
        console.error("Error fetching rules:", err);
        alert(err.response?.data?.detail || "Failed to load rules.");
      } 
    },

    searchData() {
      this.currentPage = 1;
      this.getRules();
    },

    loadPage(page) {
      this.currentPage = page;
      this.getRules();
    },

    SortSelected(property) {
      if (this.SortProperty === property) {
        this.SortOrder = this.SortOrder === "asc" ? "desc" : "asc";
      } else {
        this.SortProperty = property;
        this.SortOrder = "asc";
      }
      this.getRules();
    },

    closeModal() {
      this.$emit("closeModal");
    },

    assignRule() {
      this.editingRuleId = null;
      this.viewMode = false;
      this.showCreateRuleModal = true;
    },

    editRule(rule) {
      this.editingRuleId = rule.id;
      this.viewMode = false;
      this.showCreateRuleModal = true;
    },
   viewRule(rule) {
    this.editingRuleId = rule.id;
    this.viewMode = true;
    this.showCreateRuleModal = true;
  },
    refreshRuleList() {
      this.getRules();
    },

    ruleTypeBadgeClass(ruleType) {
      const map = {
        Full: "badge-primary",
        Percentage: "badge-info",
        Sequential: "badge-warning",
        None: "badge-secondary",
      };
      return map[ruleType] || "badge-secondary";
    },

    async deleteRule(rule) {
      if (!confirm(this.$t("navigations.are you sure you want to delete this rule?"))) return;
      try {
        await axios.delete(
          `${this.baseurl}/management/sdv/deletesdvplanrule?id=${rule.id}`,
          { headers: { Authorization: "Bearer " + this.token, "Content-Type": "application/json" } }
        );
        alert(this.$t("navigations.rule deleted successfully"));
        this.getRules();
      } catch (err) {
        console.error("Delete error:", err);
        alert(err.response?.data?.detail || "Delete failed");
      }
    },
       async setroleprivileges() {
           this.roleprivileges = await store.getters.getRolesprivilegeData;
           console.log(this.roleprivileges);
         },
        async loadSites() {
  try {
    const response = await axios.get(
      `${this.baseurl}/management/site/getallsitesbyuser?studyId=${this.studyId}&sortProperty=siteCode&IsDes=false&getAll=true`,
      { headers: { Authorization: "Bearer " + this.token } }
    );
    const sites = response.data || [];
    this.sitesMap = sites.reduce((map, site) => {
      map[site.siteID] = { siteCode: site.siteCode, siteName: site.siteName };
      return map;
    }, {});
  } catch (err) {
    console.error("Error loading sites:", err);
  }
},

async loadVisits() {
  try {
    const response = await axios.get(
      `${this.baseurl}/management/visit/listvisit?StudyId=${this.studyId}&pageindex=1&pagesize=9999&SortProperty=visitNo&ConvertToNumeric=true&SortOrder=0`,
      { headers: { Authorization: "Bearer " + this.token } }
    );
    const visits = response.data?.results || [];
    this.visitsMap = visits.reduce((map, visit) => {
      map[visit.visitId] = visit.visitFormName;
      return map;
    }, {});
  } catch (err) {
    console.error("Error loading visits:", err);
  }
},

  getSiteCodes(siteIds) {
    if (!siteIds || siteIds.length === 0) return '—';
    return siteIds
      .map(id => this.sitesMap[id]?.siteCode || id)
      .join(', ');
  },

getVisitNames(visitIds) {
  if (!visitIds || visitIds.length === 0) return '—';
  return visitIds
    .map(id => this.visitsMap[id] || id)
    .join(', ');
},
  },
};